import React from 'react';
import PropTypes from 'prop-types';
import { LocationList } from '../../../../components/LocationList';

export default function LocationListFromJSON({
  heading,
  viewAllButtonLabel,
  locations,
  maxColumns,
}) {
  return (
    <LocationList
      headerText={heading}
      viewAllButtonLabel={viewAllButtonLabel}
      locations={locations}
      containerId="location-list"
      spacing="x-large 0"
      maxColumns={maxColumns}
    />
  );
}

LocationListFromJSON.propTypes = {
  /**
   * A heading for the list of brand locations
   */
  heading: PropTypes.string.isRequired,

  /**
   * Label for the ‘view all’ button
   */
  viewAllButtonLabel: PropTypes.string.isRequired,

  /**
   *
   */
  maxColumns: PropTypes.oneOf([2, 3, 4, 5, 6]).isRequired,

  /**
   * An array of locations, from raw JSON in theStoryblok API
   */
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
